import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { message } from 'antd';
import { setSavingData } from '../Reducers/documentInfoSlice';
import { calculateFileSize } from '../Utils/helper';

const API_BASE_URL = 'https://spaces.workw.com/api/space';
// const API_BASE_URL = 'https//192.168.100.1:3000/api/space';

// Create Space
export const createSpace = createAsyncThunk(
    'mileSpace/createSpace',
    async (spaceData, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/create`, spaceData);
            return response.data;
        } catch (error) {
            message.error(error.response?.data?.message || 'Failed to create space');
            return rejectWithValue(error.response?.data);
        }
    }
);

// Get All Spaces or create new Space
export const getSpaceData = createAsyncThunk(
    'mileSpace/getAllSpaces',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getDocument/${id}`);
            const size = calculateFileSize(response?.data);
            dispatch(setSavingData({
                isSaving: '',
                lastSavedDateTime: '',
                fileSize: size,
            }));
            return response.data;
        } catch (error) {
            const statusCode = error.response?.status;
            if (statusCode === 409) {
                try {
                    await axios.patch(`${API_BASE_URL}/update/${id}`, {
                        backgroundImage: '',
                        shapes: [],
                        shapePositions: {},
                    });
                    dispatch(setSavingData({
                        isSaving: '',
                        lastSavedDateTime: '',
                        fileSize: "0 Bytes",
                    }));
                } catch (updateError) {
                    return rejectWithValue(updateError.response?.data);
                }
            }
            // message.error(error.response?.data?.message || 'Failed to fetch spaces');
            return rejectWithValue(error.response?.data);
        }
    }
);

export const updateSpace = createAsyncThunk(
    'mileSpace/updateSpace',
    async ({ id, updatedData }, { rejectWithValue }) => {
        try {
            const response = await axios.patch(`${API_BASE_URL}/update/${id}`, { data: updatedData });
            return response.data;
        } catch (error) {
            message.error(error.response?.data?.message || 'Failed to update space');
            return rejectWithValue(error.response?.data);
        }
    }
);





